var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M728.637 192.387s-16.398-88.141-133.643-142.582C477.75-4.635 423.461 49.54 364.516 72.14c-58.945 22.6-90.92-8.509-189.308-23.199C76.821 34.251-8.448 180.29 19.428 294.354c27.877 114.065 89.369 154.68 223.831 180.604 134.463 25.923 213.993-59.626 309.1-44.071s208.254-71.723 176.278-238.5Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.637 192.387s-16.398-88.141-133.643-142.582C477.75-4.635 423.461 49.54 364.516 72.14c-58.945 22.6-90.92-8.509-189.308-23.199C76.821 34.251-8.448 180.29 19.428 294.354c27.877 114.065 89.369 154.68 223.831 180.604 134.463 25.923 213.993-59.626 309.1-44.071s208.254-71.723 176.278-238.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.24 392.822a.36.36 0 0 1-.206-.446c4.904-15.03 17.51-26.605 32.897-30.209a.36.36 0 1 1 .165.702c-15.144 3.547-27.55 14.94-32.377 29.731a.36.36 0 0 1-.454.231l-.026-.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.32 383.178c-3.4-2.812-8.782 1.852-8.699 2.017-.38.655-.746 1.322-1.095 2 .747-.689 3.213-1.08 6.457-.355 3.241.601 6.673-1.103 3.336-3.662ZM678.14 375.52c-3.433-2.639-5.111 3.088-2.87 5.758 2.107 2.688 3.244 4.88 3.199 5.89.303-.701.623-1.394.96-2.076-.17-.022 1.868-6.954-1.29-9.572ZM692.68 378.302c-2.88-3.335-8.924.299-8.868.466-.48.572-.946 1.158-1.399 1.756.845-.538 3.329-.486 6.395.787 3.084 1.155 6.732.076 3.873-3.01ZM683.933 369.042c-2.942-3.174-5.524 2.15-3.756 5.143 1.632 2.993 2.392 5.329 2.184 6.303.411-.63.838-1.247 1.28-1.854-.165-.043 2.963-6.475.292-9.592ZM697.775 374.243c-2.287-3.766-8.831-1.21-8.8-1.042-.566.48-1.12.975-1.662 1.484.918-.382 3.35.094 6.154 1.866 2.84 1.661 6.61 1.212 4.308-2.308ZM690.7 363.65c-2.371-3.62-5.794 1.189-4.546 4.428 1.112 3.22 1.477 5.643 1.114 6.562a45.264 45.264 0 0 1 1.56-1.6c-.158-.064 3.98-5.866 1.872-9.39ZM703.485 371.086c-1.628-4.094-8.518-2.661-8.511-2.492-.637.379-1.265.773-1.884 1.183.967-.222 3.283.655 5.752 2.87 2.52 2.114 6.32 2.296 4.643-1.56ZM698.285 359.457c-1.734-3.965-5.928.212-5.236 3.614.558 3.362.515 5.811.004 6.655.59-.453 1.19-.891 1.803-1.315-.15-.088 4.911-5.124 3.43-8.954ZM709.696 368.919c-.919-4.313-8.007-4.042-8.022-3.873-.695.268-1.383.554-2.064.856.993-.059 3.135 1.19 5.204 3.787 2.134 2.503 5.88 3.315 4.882-.77ZM706.535 356.578c-1.043-4.202-5.933-.776-5.825 2.698-.022 3.41-.48 5.82-1.128 6.569a45.068 45.068 0 0 1 2.007-1c-.14-.111 5.75-4.242 4.946-8.267ZM705.698 363.412c-.102-.059 5.247-3.657 8.73-4.225 3.406-.657 4.706 1.743 4.144 3.15-.542 1.423-2.933 1.784-4.96 1.664-1.992-.28-7.885-.692-7.914-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.606 363.634a.246.246 0 0 1-.147-.269.094.094 0 0 1 .009-.022c.018-.065.033-.114.12-.146.86-.824 5.808-3.76 8.802-4.247 1.677-.324 3.112.058 3.933 1.05.59.715.776 1.667.472 2.426-.733 1.925-4.163 1.876-5.196 1.815-1.944-.272-7.309-.645-7.82-.603a.24.24 0 0 1-.173-.004Zm11.32-4.07c-.568-.232-1.361-.351-2.452-.14-2.748.447-6.626 2.78-8.05 3.739.505.02 1.289.072 2.512.16 1.577.115 3.642.29 4.71.44 1.941.114 4.21-.222 4.702-1.512.24-.601.084-1.363-.396-1.944a2.598 2.598 0 0 0-1.026-.742ZM676.5 392.529a.36.36 0 0 1-.466-.153c-7.676-13.821-7.58-30.935.251-44.663a.36.36 0 1 1 .626.357c-7.706 13.51-7.801 30.354-.247 43.956a.36.36 0 0 1-.14.49l-.024.013Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.654 377.115c-4.373.577-4.618 7.694-4.441 7.745.22.725.461 1.447.72 2.164.004-1.016 1.396-3.089 4.134-4.973 2.646-1.966 3.733-5.64-.413-4.936ZM665.115 379.362c-4.269.72-1.215 5.846 2.266 6.021 3.405.286 5.785.945 6.494 1.665-.308-.7-.598-1.405-.868-2.117-.132.11-3.825-6.1-7.892-5.569ZM677.05 370.6c-4.405-.157-5.855 6.743-5.694 6.816.092.741.204 1.482.334 2.22.18-.985 1.91-2.77 4.928-4.15 2.945-1.473 4.637-4.88.431-4.885ZM664.311 370.709c-4.327-.004-2.184 5.51 1.212 6.252 3.305.841 5.533 1.873 6.105 2.689a45.1 45.1 0 0 1-.488-2.2c-.143.092-2.727-6.577-6.829-6.741ZM677.541 364.106c-4.315-.887-6.896 5.647-6.751 5.74-.033.74-.048 1.483-.044 2.227.344-.933 2.348-2.39 5.555-3.24 3.15-.95 5.386-4.018 1.24-4.727ZM664.965 362.081c-4.265-.725-3.072 5.054.151 6.345 3.117 1.376 5.14 2.757 5.566 3.65a45.413 45.413 0 0 1-.11-2.233c-.155.072-1.59-6.908-5.607-7.762ZM679.115 357.773c-4.109-1.593-7.748 4.431-7.619 4.541a45.15 45.15 0 0 0-.414 2.186c.495-.86 2.713-1.96 6.017-2.262 3.264-.408 5.983-3.069 2.016-4.465ZM667.055 353.67c-4.085-1.428-3.879 4.488-.915 6.296 2.843 1.879 4.608 3.578 4.879 4.525.07-.74.157-1.478.263-2.215-.166.05-.412-7.086-4.227-8.606ZM681.753 351.748c-3.785-2.262-8.41 3.116-8.297 3.242a45.05 45.05 0 0 0-.777 2.095c.632-.768 3.006-1.488 6.316-1.236 3.286.14 6.43-2.053 2.758-4.101ZM670.56 345.666c-3.789-2.096-4.607 3.82-1.988 6.104 2.484 2.337 3.938 4.313 4.046 5.296.193-.72.404-1.437.633-2.15-.177.027.805-7.1-2.691-9.25ZM674.997 350.93c-.112.035.89-6.334 2.846-9.273 1.836-2.943 4.48-2.261 5.128-.892.673 1.365-.69 3.363-2.156 4.766-1.56 1.27-5.874 5.307-5.818 5.399Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.098 351.148a.246.246 0 0 1-.297-.076.097.097 0 0 1-.011-.02c-.035-.058-.06-.103-.025-.188-.02-1.191 1.198-6.814 2.878-9.34.903-1.449 2.16-2.241 3.446-2.167.925.054 1.75.566 2.099 1.305.911 1.847-1.459 4.327-2.207 5.042-1.521 1.24-5.446 4.917-5.763 5.32a.24.24 0 0 1-.12.124Zm4.721-11.063c-.557.257-1.184.757-1.772 1.7-1.542 2.318-2.472 6.747-2.738 8.443.358-.356.93-.895 1.827-1.732 1.157-1.077 2.691-2.47 3.527-3.151 1.404-1.345 2.703-3.237 2.092-4.474-.277-.586-.942-.99-1.694-1.034a2.598 2.598 0 0 0-1.242.248ZM80.89 392.827a.295.295 0 0 0 .168-.364c-4.009-12.287-14.313-21.749-26.892-24.695a.294.294 0 1 0-.134.574c12.38 2.9 22.52 12.212 26.466 24.304.05.154.217.239.371.188l.021-.007Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.015 384.944c2.78-2.299 7.178 1.513 7.11 1.648.311.536.61 1.08.896 1.636-.611-.564-2.627-.883-5.278-.291-2.65.491-5.455-.901-2.728-2.993ZM79.337 378.683c2.805-2.157 4.177 2.524 2.345 4.707-1.722 2.198-2.652 3.99-2.615 4.815-.247-.573-.51-1.14-.785-1.697.139-.018-1.526-5.685 1.054-7.825ZM67.45 380.957c2.356-2.725 7.295.245 7.25.382.392.467.773.946 1.143 1.435-.69-.44-2.72-.397-5.227.643-2.52.944-5.503.062-3.166-2.46ZM74.6 373.388c2.405-2.594 4.516 1.757 3.071 4.204-1.334 2.447-1.956 4.356-1.785 5.152a36.883 36.883 0 0 0-1.046-1.515c.134-.035-2.423-5.293-.24-7.84ZM63.286 377.64c1.87-3.079 7.219-.99 7.194-.852.462.393.915.797 1.358 1.213-.75-.313-2.738.076-5.03 1.525-2.322 1.358-5.403.991-3.522-1.887ZM69.07 368.98c1.938-2.958 4.735.972 3.715 3.62-.909 2.633-1.207 4.613-.91 5.364-.414-.446-.84-.882-1.275-1.308.129-.052-3.254-4.795-1.53-7.676ZM58.618 375.06c1.33-3.348 6.963-2.177 6.958-2.038.52.31 1.034.632 1.54.967-.791-.181-2.684.535-4.703 2.347-2.06 1.727-5.166 1.876-3.795-1.277ZM62.868 365.553c1.418-3.241 4.846.173 4.281 2.954-.456 2.748-.42 4.75-.004 5.44a37.16 37.16 0 0 0-1.473-1.075c.122-.072-4.015-4.188-2.804-7.319ZM53.541 373.287c.75-3.525 6.545-3.303 6.558-3.165.568.22 1.13.452 1.687.7-.812-.049-2.563.972-4.254 3.095-1.744 2.046-4.807 2.71-3.991-.63ZM56.125 363.2c.852-3.435 4.85-.635 4.761 2.204.018 2.789.393 4.76.922 5.37a36.747 36.747 0 0 0-1.64-.816c.115-.092-4.7-3.468-4.043-6.758ZM56.81 368.786c.082-.048-4.29-2.99-7.138-3.454-2.784-.537-3.846 1.425-3.387 2.575.443 1.163 2.398 1.458 4.054 1.36 1.629-.228 6.446-.566 6.47-.481Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.884 368.968.023-.012a.202.202 0 0 0 .097-.208l-.006-.019c-.015-.053-.028-.093-.1-.119-.702-.674-4.747-3.073-7.194-3.471-1.37-.265-2.544.046-3.215.858-.483.584-.634 1.363-.386 1.983.599 1.573 3.403 1.533 4.248 1.483 1.588-.221 5.974-.526 6.392-.492a.197.197 0 0 0 .14-.003Zm-9.253-3.327c.464-.19 1.113-.288 2.004-.116 2.246.366 5.417 2.273 6.58 3.057-.412.016-1.053.059-2.053.131-1.289.094-2.977.237-3.85.36-1.587.093-3.442-.182-3.843-1.236-.197-.492-.07-1.115.323-1.59.16-.192.426-.436.839-.606ZM80.677 392.587a.295.295 0 0 0 .381-.124c6.274-11.299 6.196-25.289-.206-36.51a.294.294 0 1 0-.511.292c6.3 11.044 6.377 24.812.202 35.932a.295.295 0 0 0 .114.4l.02.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.733 379.987c3.575.472 3.775 6.29 3.63 6.332a36.54 36.54 0 0 1-.588 1.769c-.003-.832-1.14-2.526-3.379-4.066-2.163-1.607-3.052-4.61.337-4.035ZM89.983 381.824c3.49.588.994 4.78-1.852 4.922-2.783.234-4.729.772-5.308 1.361.252-.572.488-1.149.71-1.73.107.089 3.126-4.987 6.45-4.553ZM80.228 374.662c3.6-.129 4.785 5.512 4.654 5.572-.076.605-.167 1.21-.274 1.814-.147-.805-1.56-2.264-4.028-3.392-2.407-1.205-3.79-3.99-.352-3.994ZM90.64 374.75c3.538-.003 1.786 4.505-.99 5.111-2.701.688-4.523 1.532-4.99 2.198.147-.596.28-1.195.398-1.797.117.075 2.23-5.377 5.582-5.511ZM79.826 369.353c3.527-.725 5.637 4.616 5.519 4.692a36.8 36.8 0 0 1 .035 1.82c-.281-.762-1.919-1.954-4.54-2.648-2.576-.777-4.404-3.284-1.014-3.864ZM90.106 367.698c3.487-.593 2.51 4.132-.124 5.187-2.547 1.125-4.202 2.254-4.55 2.983.045-.608.076-1.216.09-1.825.127.059 1.3-5.647 4.584-6.345ZM78.54 364.177c3.358-1.303 6.332 3.621 6.227 3.712.128.592.24 1.187.339 1.786-.405-.703-2.218-1.602-4.919-1.849-2.668-.333-4.89-2.508-1.647-3.65ZM88.397 360.822c3.34-1.167 3.171 3.669.749 5.147-2.324 1.536-3.767 2.924-3.988 3.7a37.021 37.021 0 0 0-.216-1.812c.136.041.337-5.792 3.455-7.035ZM76.383 359.25c3.094-1.848 6.874 2.549 6.782 2.652.226.565.438 1.136.635 1.712-.517-.628-2.457-1.216-5.163-1.01-2.686.114-5.256-1.679-2.254-3.353ZM85.533 354.28c3.097-1.714 3.766 3.121 1.625 4.989-2.031 1.91-3.22 3.526-3.308 4.33a36.885 36.885 0 0 0-.517-1.758c.144.022-.658-5.804 2.2-7.562ZM81.906 358.582c.091.029-.729-5.177-2.327-7.58-1.5-2.405-3.662-1.848-4.191-.729-.551 1.116.563 2.75 1.762 3.896 1.275 1.038 4.801 4.338 4.756 4.413Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.823 358.76.024.01a.201.201 0 0 0 .219-.071l.009-.017c.028-.047.05-.084.02-.154.016-.973-.98-5.57-2.353-7.634-.738-1.185-1.765-1.832-2.816-1.771-.757.043-1.43.462-1.716 1.066-.745 1.51 1.192 3.537 1.804 4.122 1.243 1.013 4.451 4.019 4.71 4.349.02.045.055.08.1.1Zm-3.86-9.043c.456.21.969.62 1.45 1.39 1.26 1.895 2.02 5.515 2.238 6.902-.293-.292-.76-.732-1.494-1.416-.946-.88-2.2-2.02-2.883-2.576-1.148-1.1-2.21-2.646-1.71-3.657.226-.479.77-.81 1.385-.845.25-.014.609.015 1.015.202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M719.737 392.849H35.917"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.13,
    y: 32.955,
    width: 428.905,
    height: 248.433,
    rx: 39.904,
    ry: 39.904,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.265 38.815h-349.75c-19.366 0-35.066 15.712-35.066 35.078v61.002h-.005v46.712h.005v58.644c0 19.367 15.7 35.079 35.067 35.079h349.749c19.378 0 35.078-15.712 35.078-35.079V73.894c0-19.367-15.7-35.079-35.078-35.079Z",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.613 130.298H313.945V79.494c0-.9-.524-1.716-1.342-2.09L228.24 38.819H217.19l92.159 42.15v49.329H168.444v4.597h56.658c-4.528 45.882 17.105 72.759 36.277 87.276 16.549 12.532 33.696 18.104 40.728 20.008l-21.046 33.146h5.446l37.691-59.363V216h67.241l-10.82 59.325h4.674l25.612-140.43h12.602l112.177 140.43h5.884l-50.732-63.51 65.488-48.404a2.297 2.297 0 0 0 .861-2.419l-19.542-76.304h50.699v-4.597h-95.177c-.867 0-1.66.487-2.051 1.261l-8.67 17.139-31.951-29.29 11.685-30.382h-4.925L445.64 69.013a2.3 2.3 0 0 0 .592 2.52l34.056 31.22-29.69 58.69-24.19-30.281a2.296 2.296 0 0 0-1.795-.864Zm69.965-45.61h38.32l19.45 75.946-64.383 47.587-34.213-42.83 40.826-80.703Zm-88.346 50.207-13.954 76.507h-65.185l48.576-76.507h30.563Zm-36.01 0-65.524 103.202c-5.414-1.38-23.504-6.688-40.543-19.591-26.508-20.071-38.082-48.2-34.44-83.61h140.508Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4"
    },
    d: "M377.298 38.815V45.7l43.458 17.378v34.757L378.264 79.49v27.033h-41.515v-40.55l-52.72-27.159h93.27z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 223.418 249.193)",
    style: {
      fill: "#c4c4c4"
    },
    d: "M206.177 234.826h34.481v28.734h-34.481z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 219.395 213.793)",
    style: {
      fill: "#c4c4c4"
    },
    d: "M206.982 203.449h24.826v20.688h-24.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.565 227.718 55.11-85.33H240.121s-5.925 61.035 60.443 85.33Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 215.755 185.979)",
    style: {
      fill: "#c4c4c4"
    },
    d: "M207.71 179.274h16.091v13.409H207.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4"
    },
    d: "m479.15 148.05 21.837 31.033 32.182-17.24-3.448-62.066-29.883-3.448-10.344 24.136 16.09 10.345-5.746 10.344-17.24-9.195-3.449 16.091zM414.32 247.492h62.087l14.16 27.838H413.01l1.31-27.838zM452.854 201.149h-36.358l-1.81 38.62h57.8l-19.632-38.62zM416.768 195.356h33.141l-11.78-23.173h-20.275l-1.086 23.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m228.84 41.027 1.361.629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 3.0336 3.0336",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m232.955 42.93 75.719 35.016"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m310.05 78.583 1.362.63v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 2.94996 2.94996",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M311.412 83.663v45.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M311.412 130.862v1.5h-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 2.99808 2.99808",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M306.914 132.362h-76.451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.964 132.362h-1.5s-.118.512-.286 1.468",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.736 136.762c-1.56 12.116-3.053 46.906 25.153 74.553 19.578 19.19 43.307 26.516 51.45 28.575",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 2.96889 2.96889",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.781 240.24c.948.22 1.463.316 1.463.316l.804-1.266",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 3.05762 3.05762",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m308.687 236.709 64.737-101.961"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m374.243 133.458.804-1.267h1.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 3.01083 3.01083",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M379.558 132.191h40.646"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M421.71 132.191h1.5l.937 1.171"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeDasharray: "0 0 2.93387 2.93387",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m425.981 135.652 68.77 85.878"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m495.668 222.675.938 1.171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.145 137.34-11.817 8.59-10.765-8.334-.013-.009c-4.875-3.47-8.057-9.165-8.057-15.606 0-10.566 8.568-19.13 19.134-19.13s19.13 8.564 19.13 19.13c0 6.342-2.863 11.876-7.612 15.359Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.832 121.855c0 4.08 1.454 7.823 3.87 10.741a16.8 16.8 0 0 0 12.962 6.09c4.807 0 9.138-2.01 12.208-5.237a16.785 16.785 0 0 0 4.624-11.594c0-9.295-7.532-16.832-16.832-16.832-9.296 0-16.832 7.537-16.832 16.832Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.664 138.687a16.77 16.77 0 0 0 10.889-3.996c-.55-5.69-5.343-10.139-11.177-10.139-5.676 0-10.355 4.213-11.113 9.68 2.999 2.763 7 4.455 11.4 4.455Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.375,
    cy: 116.955,
    r: 7.418,
    transform: "rotate(-80.782 217.375 116.955)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.863 187.188-11.817 8.59-10.765-8.333-.013-.01c-4.875-3.469-8.057-9.165-8.057-15.606 0-10.566 8.568-19.13 19.134-19.13s19.13 8.564 19.13 19.13c0 6.343-2.863 11.876-7.612 15.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.55 171.704c0 4.08 1.454 7.823 3.87 10.74a16.8 16.8 0 0 0 12.962 6.091c4.807 0 9.138-2.01 12.208-5.238a16.785 16.785 0 0 0 4.624-11.593c0-9.296-7.532-16.832-16.832-16.832-9.296 0-16.832 7.536-16.832 16.832Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.382 188.535a16.77 16.77 0 0 0 10.889-3.995c-.55-5.69-5.343-10.14-11.178-10.14-5.675 0-10.354 4.214-11.112 9.68 2.999 2.763 7 4.455 11.4 4.455Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.094,
    cy: 166.803,
    r: 7.418,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.038 181.74c-1.076 1.163-1.97 2.546-1.965 3.003.007.457 5.552 8.093 6.323 9.03.77.936 2.88 2.712 2.88 2.712l15.197 18.466c-.499.218-1.766.774-2.022.911-.321.172.388.697 1.192.775.803.078 2.002-.262 2.002-.262l9.063 10.563s2.8.93 4.951.176c2.152-.754 5.886-3.18 8.955-6.076 3.07-2.896 4.016-3.767 4.016-3.767s.615-.6.745-.89c.13-.292 1.2-5.055.695-6.118-.505-1.063-.988-1.313-.988-1.313s-6.973-8.585-7.336-9.026l-.037-.043c.204-.394.81-1.595.85-2.012.05-.503-.43-1.31-.65-1.128-.198.162-1.194 1.497-1.405 1.78l-15.572-19.138s-1.9-2.872-3.125-4.36c-1.225-1.487-5.4-5.998-6.239-6.232-.84-.234-1.536.155-1.701.291-.166.136-5.412 3.53-7.211 4.826-1.799 1.295-7.542 6.67-8.618 7.832Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.124 199.116 1.17-.038-8.652-10.624-2.764.796s8.441 9.134 10.246 9.866ZM478.417 187.588l2.447-1.182-9.293-10.281s.734 3.924 1.097 4.365c.363.44 5.75 7.098 5.75 7.098ZM453.546 186.34s.778-1.75 2.44-3.211c1.663-1.461 9.341-7.965 10.129-8.244.787-.278 2.495-.112 2.495-.112s-.926-2.473-1.762-3.264c-.836-.79-2.07-.606-2.391-.435-.321.172-7.03 5.047-8.767 6.754-1.737 1.707-4.706 4.612-4.9 5.05-.195.437.206 2.048.624 2.443.418.395 2.132 1.018 2.132 1.018ZM454.675 189.845s2.952 1.453 3.425 1.803 6.387 7.312 6.387 7.312l-1.776 2.109-5.956-7.575-2.08-3.649ZM464.454 202.961l1.394-2.348s3.362 4.534 4.103 5.772c.742 1.238 3.663 6.134 3.663 6.134l-.282 1.342-8.878-10.9ZM471.61 207.053s9.661-6.565 13.142-11.094l8.714 7.892s1.089 1.323 1.114 1.579c.026.256.013.913.013.913s-2.205 4.957-5.225 7.35c-3.02 2.394-8.105 4.638-8.673 4.735-.567.098-1.496-.246-1.496-.246l-1.393-.794-6.196-10.335ZM497.247 207.21s1.855 4.387 1.935 6.17c.08 1.781-.218 2.766-.218 2.766s1.427-1.636 1.524-2.64c.098-1.004.05-2.074-.284-2.816s-2.957-3.48-2.957-3.48ZM480.222 221.221s3.748 2.646 4.924 3.064c1.176.418 3.204.412 3.204.412s-1.815.94-2.427.981c-.612.042-2.965-.794-3.437-1.144-.473-.35-2.203-2.901-2.264-3.313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.74 282.016s-9.609 24.525-11.895 32.297c-2.286 7.772-3.2 19.66-3.2 19.66l73.33 7.42s12.62-3.306 11.706-10.164c-.914-6.858-9.14-19.62-20.573-30.631-11.434-11.012-28.803-20.117-34.289-20.117s-15.08 1.535-15.08 1.535Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m597.873 308.25 4.313 19.646-16.293 3.354 11.98-23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.114 329.422c-3.16-8.955-7.902-9.482-7.902-9.482l-13.696-35.294s-15.276 2.107-21.597 7.375c-6.322 5.268-21.071 38.981-21.071 38.981l11.589 73.221s47.936-10.008 49.516-11.062c1.58-1.053 3.16-11.062 3.688-17.383.526-6.322 2.633-37.401-.527-46.356Zm-58.346-1.287s12.46-26.834 15.334-30.667 7.667-5.99 7.667-5.99l9.906-2.264 9.98 31.973-42.887 6.948Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.29 330.292 13.896-2.396s5.51-10.542 7.187-11.98c1.677-1.437 4.073-2.875 8.146-1.917 4.074.959 12.699 5.75 12.22 8.865s-1.198 4.073-5.75 4.792c-4.553.719-16.532.719-16.532.719s-3.115 5.031-3.834 5.99c-.719.958-12.459 4.792-12.459 4.792s-1.437-3.834-2.875-8.865Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.17 437.427s-2.848 2.548-4.197 3.597c-1.348 1.049-3.596 2.997-5.844 3.747-2.248.749-3.447 1.198-3.297 2.397.15 1.2.15 2.398.9 2.548.748.15 27.723 0 27.723 0s.75-1.199.6-3.896c-.15-2.698-1.05-4.796-1.05-4.796s-6.893-1.948-9.89-3.597c-2.997-1.648-4.946 0-4.946 0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.902 448.367h-28.93c.1.702.27 1.25.76 1.349.748.15 27.723 0 27.723 0s.264-.437.447-1.349Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.328 335.223s-1.948 12.588 0 25.626c1.948 13.038 4.046 22.33 4.046 22.33s2.997 13.037 3.297 17.233c.3 4.196 3.147 26.375 2.997 26.825-.15.45-.45 1.499-.45 2.248 0 .75-1.948 1.798-1.648 2.697.3.9.6 5.245.6 5.245s3.446-.599 4.945 0 8.242 2.998 8.242 2.998l1.649.599s1.798-1.349 1.798-3.447-2.698-4.496-2.698-4.496 1.799-.749 1.949-1.498c.15-.75-.75-3.447-.75-3.897s-.3-4.945-.3-5.844.15-12.289.15-13.637-1.348-22.03-1.348-22.03l-1.499-14.986s3.597 16.935 5.095 22.33c1.499 5.394 5.845 28.023 5.995 28.773.15.749.749 6.593.6 7.043-.15.45-1.8 1.499-1.65 2.098.15.6 1.2 8.092 1.2 8.092l10.79.9s1.198-2.248 1.798-3.897c.6-1.648-.45-3.147-.45-3.746 0-.6.9-.45.6-2.848-.3-2.397-.6-4.346-.6-4.346s-.75-1.198-.899-5.394c-.15-4.197 2.248-15.736.6-22.33-1.649-6.593-3.597-12.138-3.747-19.331-.15-7.194-.15-20.68-.75-24.278-.599-3.596-1.56-14.845-1.56-14.845l-.388-1.64-37.614-2.547Z",
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m545.216 355.904 5.694 2.697 1.948 10.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.746 437.277s-1.049 3.747-2.098 5.545c-1.049 1.799-2.697 2.848-3.147 3.897-.45 1.049-.3 2.997-.3 2.997h16.036s1.198-1.499 1.198-5.095-1.348-5.395-2.547-7.493c-1.199-2.098-5.245-3.597-9.142.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.086 447.677-.25-.06h-16.569c-.15.994-.065 2.099-.065 2.099h16.035s.495-.634.849-2.039Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.628 270.8s-2.963 3.048-5.313 4.34c-2.35 1.293-6.227 2.468-6.932 3.878-.705 1.41-1.528 11.162-.47 16.214 1.057 5.052 2.35 8.577 2.35 8.577l.822 18.682-1.292 14.334s14.216 1.88 23.264 2.938 15.274-.353 15.274-.353.47-8.577.587-13.042c.118-4.465.353-25.496.353-25.496l7.167 11.984s4.99 3.226 13.068-1.99c2.28-1.472-6.48-10.863-7.068-13.8-.587-2.938-4.355-9.236-4.355-9.236s-3.055-9.165-5.405-11.514-5.522-2.938-8.93-3.408c-3.407-.47-9.025-2.793-9.025-2.793l-14.095.685Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.765 300.432s-3.702.504-4.712 6.9M576.697 302.956s2.524-2.525 5.385-2.525",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.644 247.504s.293 10.18.685 11.844c.392 1.664 3.132 5.09 4.307 6.656 1.175 1.566 3.622 1.958 3.915 1.958.294 0 1.077 1.174 1.077 2.838s-.685 1.958-.587 6.754c.098 4.797.783 8.908.783 8.908s2.838-1.86 7.733-7.146c4.894-5.286 6.166-9.2 6.166-9.2s-2.153-1.959-2.838-4.21c-.686-2.251-.588-7.928-.588-7.928s3.524-2.741 3.72-4.307c.196-1.567-1.273-4.503-1.273-4.503s-1.664-5.873-3.523-8.81c-1.86-2.936-2.154-4.404-8.32-2.74-6.167 1.664-8.32 2.055-10.278 3.523-1.958 1.469-2.252 3.23-2.252 3.23l1.273 3.133Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.551 267.962s1.86-.196 2.937-.49c1.077-.293 2.545-.88 2.545-.88l-4.405 4.208-1.077-2.838Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.213 258.641s.685 1.077 1.664.686c.979-.392 1.531-.665 1.531-.665M538.908 261.501s3.524.49 5.58-2.447M540.181 250.93s3.132-.881 4.796 0M536.07 251.321s-1.664-1.076-2.643.196",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.125 253.682c.078.646-.138 1.204-.482 1.245-.343.041-.685-.45-.762-1.096-.078-.647.138-1.204.482-1.245.343-.041.685.45.762 1.096ZM542.12 253.41c.078.646-.138 1.203-.482 1.244-.344.042-.685-.45-.763-1.096-.077-.646.139-1.204.482-1.245.344-.041.685.45.763 1.096Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.837 241.435s-3.328 2.545-4.405 2.74c-1.077.197-4.894-1.076-6.264-1.174-1.37-.098-3.916 1.958-3.916 1.958l.392 2.545s-3.72-.881-4.503-2.35c-.783-1.468 1.86-3.425 1.762-3.915-.098-.49-1.468-2.349-.49-2.936.98-.588 5.286-1.958 5.286-1.958s2.252-4.698 3.818-4.796c1.566-.098 4.503.49 4.503.49s1.566-1.469 3.425-1.175c1.86.293 4.601 3.72 4.601 3.72s4.111-.392 4.894 1.37c.783 1.761 1.566 4.11.98 5.97s-1.176 5.776-1.176 5.776v1.468s-1.664.293-2.447.979c-.783.685-.685 1.272-1.272 1.762s-.881.49-1.273.293-.587-.783-.783-1.957c-.195-1.175-.391-1.469-1.174-1.762-.783-.294-1.86-.881-2.643-1.762-.783-.881-1.762-1.664-1.175-2.447.588-.783 1.86-2.839 1.86-2.839Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m566.924 294.762 4.347 6.11-7.285-2.468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.951 337.871c-.372-1.168 11.62.677 11.62.677s3.795-16.744 2.74-18.553c-1.056-1.809-10.849-5.24-10.849-5.24l-22.76-1.207s-9.799 4.145-9.95 5.2c-.08.56-6.474 8.467-9.19 14.727l38.39 4.396Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.431 312.67s-1.427 1.428-1.427 5.474 2.617 9.28 2.617 9.28l9.042-4.76 10.505 5.376s1.048-10.013-2.706-13.286c-3.753-3.273-15.889-4.939-18.03-2.083Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.013 314.49s1.919 5.504 3.911 9.24c1.992 3.735 6.475 6.474 6.475 6.474s2.241-7.471 2.49-11.206c.25-3.736-.249-5.728-.249-5.728l-12.627 1.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.103 304.48s.834 8.222 1.668 8.937c.834.715 5.242 1.072 5.242 1.072l9.533.596c.953-1.787 1.549-12.034-1.788-19.898-3.336-7.865-7.506-9.175-8.34-7.745 0 0-4.886 6.672-4.647 8.102.238 1.43.715 2.145.476 2.86-.238.715-3.098 2.025-3.455 3.336-.358 1.31 1.31 2.74 1.31 2.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.366 306.03s2.622 0 3.933-1.192M356.392 298.642s1.31-.357 2.145.477M355.558 296.02s2.264-2.144 3.575.716",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.418 287.442s.953 8.102 3.693 13.94c2.741 5.839 4.052 7.626 4.052 7.626s0 4.647-1.43 5.958c-1.43 1.31-2.979 1.192-2.979 1.192s-1.668 2.383 3.694 3.098 6.791-1.788 8.698-2.026c1.906-.238 2.86.12 2.86.12s.476-1.43.119-2.98c-.358-1.549-.596-2.74-.596-2.74s3.575-4.17 3.455-8.937 1.311-7.506-1.31-13.107-16.443-6.553-19.065-6.672c-2.621-.12-2.979.119-4.17 2.025-1.192 1.907-4.647 4.766-4.647 6.911s3.455 6.554 3.455 6.554l-.476-2.86s2.86-4.885 4.647-8.102ZM445.356 421.484c-112.519-3.572-203.734 5.019-203.734 19.189 0 5.98 16.25 12 43.492 17.227-24.624.5-42.575 2.044-42.575 3.872 0 2.233 26.747 4.043 59.742 4.043 11.94 0 23.051-.238 32.383-.646 31.872 3.615 69.877 6.334 110.692 7.63 112.519 3.572 203.733-5.019 203.733-19.19s-91.214-28.552-203.733-32.125Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.776 403.15s2.48 5.368 4.247 7.2c1.768 1.83 33.733 9.739 33.733 9.739l103.564 22.666 12.55-1.343 43.86 1.404s8.751-21.409-.806-42.5c-9.556-21.09-57.34-29.328-70.85-25.044-13.512 4.284-45.148 18.124-67.886 10.545-22.738-7.58-40.863-22.409-48.442-20.432-7.58 1.978-11.205 14.17-11.205 19.443s1.235 18.323 1.235 18.323Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.422 432.478c-.903-21.768-15.465-39.45-32.525-39.494h-18.494l.323 7.798c-7.225 7.17-11.619 18.622-11.083 31.538.536 12.917 5.88 24.394 13.702 31.602l.328 7.893h18.494c17.06.043 30.158-17.568 29.255-39.337Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.038,
    cy: 432.399,
    rx: 30.813,
    ry: 39.509,
    transform: "rotate(-6.318 420.038 432.4)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.935 445.814.001-.003c.303-.974.568-1.973.793-2.995v-.003c.226-1.022.412-2.067.557-3.132h0c.314-2.322.438-4.735.335-7.216-.219-5.286-1.416-10.277-3.347-14.698l-.054-.12a37.55 37.55 0 0 0-1.4-2.847 35.751 35.751 0 0 0-1.697-2.802l-.088-.136c-4.997-7.367-12.34-12.087-20.351-12.107-6.86-.018-12.941 3.418-17.303 9.014h0c-.289.37-.57.75-.843 1.14h0c-.273.388-.537.784-.793 1.19l-.006.009a30.6 30.6 0 0 0-.734 1.223l-.02.033c-.23.408-.454.823-.669 1.246l-.032.061c-.209.412-.41.83-.603 1.256l-.046.102c-.186.412-.364.83-.535 1.255l-.06.147a34.34 34.34 0 0 0-.468 1.251l-.07.193c-.14.407-.274.82-.401 1.236-.026.083-.053.165-.078.25-.12.399-.23.804-.337 1.211-.027.104-.057.206-.083.31a37.4 37.4 0 0 0-.275 1.185c-.028.124-.057.246-.083.37-.08.382-.15.767-.218 1.154-.025.145-.054.287-.078.433-.061.373-.113.75-.164 1.128-.022.163-.047.323-.067.486-.045.367-.08.739-.115 1.11-.016.177-.037.352-.052.53-.03.367-.048.738-.068 1.11-.01.185-.025.368-.032.555-.015.39-.02.786-.024 1.18-.001.17-.009.336-.009.505.001.565.013 1.134.036 1.706.029.693.08 1.38.142 2.062.015.164.033.327.05.49.06.588.131 1.17.215 1.748l.037.267c.217 1.434.507 2.837.861 4.205v.001h0c1.766 6.8 5.171 12.709 9.583 16.955l.164.158c.54.512 1.095 1 1.663 1.46l.116.092c4.138 3.319 8.985 5.259 14.107 5.272 5.158.013 9.874-1.929 13.753-5.268v-.001h0c3.942-3.394 7.012-8.237 8.79-13.961Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.694 433.457a34.496 34.496 0 0 0-2.152-10.706l-10.164 6.368c.439 1.35.718 2.798.78 4.315.01.217.001.429.002.643l11.543 1.88c.025-.824.026-1.657-.009-2.5ZM424.682 421.776c1.056.578 2.025 1.373 2.88 2.335l7.156-11.011c-2.486-2.72-5.423-4.773-8.62-5.945l-1.416 14.621ZM429.707 440.603a11.415 11.415 0 0 1-1.9 2.747l5.877 13.153c2.816-2.36 5.117-5.586 6.693-9.394l-10.67-6.506ZM412.414 426.585l-10.363-7.21c-1.52 3.543-2.402 7.604-2.477 11.95l11.586.331c.124-1.847.562-3.566 1.254-5.07ZM415.94 422.202a8.265 8.265 0 0 1 2.768-1.27l-1.696-14.618c-3.666.65-6.984 2.484-9.718 5.199l8.646 10.689ZM422.767 446.054c-.361.05-.727.08-1.1.079a8.274 8.274 0 0 1-3.057-.603l-5.68 12.598c2.867 1.693 6.035 2.646 9.34 2.653.901.001 1.785-.075 2.653-.21l-2.156-14.517ZM412.33 438.849l-11.46 2.563c1.184 4.19 3.123 7.949 5.591 11.02l7.355-10.853a14.276 14.276 0 0 1-1.487-2.73ZM295.971 410.47c-.424-18.24-7.256-33.056-15.26-33.093H262.26l1.534 66.054h18.45c8.005.037 14.15-14.72 13.727-32.96Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52 410.47c.425 18.24-5.721 32.998-13.726 32.961-8.004-.036-14.837-14.853-15.26-33.093-.424-18.24 5.721-32.998 13.726-32.961 8.005.037 14.837 14.853 15.26 33.093Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24 421.644v-.002c.142-.816.267-1.653.373-2.51v-.002c.106-.857.193-1.732.26-2.625v0c.148-1.945.207-3.967.158-6.046-.103-4.43-.665-8.61-1.57-12.316l-.026-.1a45.28 45.28 0 0 0-.657-2.386l-.043-.143a39.328 39.328 0 0 0-.753-2.205l-.041-.114c-2.345-6.173-5.79-10.128-9.55-10.145-3.218-.015-6.071 2.864-8.118 7.554h0v0c-.135.31-.267.628-.395.955h0a30.96 30.96 0 0 0-.373.997l-.002.007c-.119.335-.234.677-.345 1.025l-.009.028c-.108.342-.213.69-.314 1.044l-.015.051c-.098.345-.192.696-.283 1.053l-.022.085c-.087.345-.17.696-.25 1.052l-.029.123c-.076.345-.15.695-.22 1.048l-.032.162c-.066.34-.128.686-.188 1.035l-.037.21c-.056.334-.108.673-.158 1.015-.013.087-.027.172-.039.26-.046.327-.088.659-.13.992l-.038.31c-.037.32-.07.643-.102.968l-.037.362a58.47 58.47 0 0 0-.077.945c-.01.136-.022.27-.031.407-.021.308-.038.62-.054.93-.008.149-.018.296-.024.445-.014.307-.023.618-.032.93-.005.155-.012.308-.015.465-.008.327-.01.658-.012.99 0 .14-.004.28-.004.422a62.53 62.53 0 0 0 .083 3.157l.024.411c.028.492.061.98.1 1.465.007.074.012.149.018.223.102 1.202.238 2.377.405 3.524h0c.828 5.699 2.426 10.65 4.496 14.208.026.044.05.089.077.132.253.43.513.837.78 1.223l.055.078c1.941 2.78 4.215 4.406 6.619 4.417 2.42.011 4.633-1.616 6.453-4.415h0c1.85-2.844 3.29-6.902 4.124-11.699Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.535 419.865c-.903-21.769-15.465-39.45-32.525-39.494h-18.494v0c-17.06-.044-30.158 17.567-29.255 39.336.903 21.768 15.465 39.45 32.525 39.494h18.494c17.06.044 30.158-17.568 29.255-39.336Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.876 405.906s-.689-13.776-2.41-18.597c-1.722-4.822-6.888-12.054-6.888-12.054s-5.166-12.053-13.776-19.63c-8.61-7.577-22.73-15.153-26.173-16.875-3.444-1.722-7.921-2.755-14.465-7.232-6.543-4.477-47.18-32.717-59.923-40.294-12.742-7.576-40.294-11.364-45.804-12.398-5.51-1.033-68.877-5.51-90.918-5.51s-67.5 1.033-92.64 10.676c0 0-8.266 2.411-9.3 4.822a203.28 203.28 0 0 0-1.721 4.132l-24.796 36.161s-8.954-.689-11.71 6.888c-2.754 7.576-1.721 17.908-1.721 17.908s-6.544 16.186-6.888 28.24c-.344 12.053 1.033 21.008 1.033 21.008s-1.722-22.041 3.444-28.93c5.166-6.887 15.842-1.721 19.975 10.677 4.132 12.398 8.954 35.472 8.954 35.472l109.17 22.385s-5.51-28.928 1.723-45.46c7.232-16.53 40.982-15.497 47.18 14.465 6.2 29.962 4.133 35.472 4.133 35.472s23.074 4.822 93.33 3.789c70.255-1.034 108.826-9.299 119.158-12.054 0 0 2.41-12.742 3.1-20.319.688-7.576-2.067-12.742-2.067-12.742Zm-250.37-69.222c-.689 1.722-2.066 2.755-2.066 2.755-2.755 2.755-10.332 0-10.332 0s-32.77-5.209-62.069-9.778c1.768-18.815 10.492-36.96 15.837-46.55 5.56.453 17.57 1.963 31.423 11.902 15.842 11.365 27.896 39.949 27.207 41.67Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.753 318.748s-13.448 15.69-13.946 17.433c-.498 1.743.747 7.47 5.479 7.72 4.731.249 30.853-9.196 30.853-9.196l-15.976-2.138 1.31-3.857",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m335.531 331.449 13.632 1.118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.943 418.648c.688-7.577-2.067-12.742-2.067-12.742s-.22-4.408-.724-9.11c-43.09 12.715-120.196 13.573-141.699 11.676-24.701-2.18-68.529-8.155-70.472-15.257-1.943-7.102-18.889-23.249-30.513-27.608-9.964-3.736-125.608-19.748-158.444-24.247-1.007 6.326-.393 12.543-.393 12.543s-6.544 16.186-6.888 28.24c-.344 12.053 1.033 21.008 1.033 21.008s-1.722-22.041 3.444-28.93c5.166-6.887 15.842-1.721 19.975 10.677 4.132 12.398 8.954 35.472 8.954 35.472l109.17 22.385s-5.51-28.928 1.723-45.459c7.232-16.53 40.982-15.498 47.18 14.464 6.2 29.962 4.134 35.472 4.134 35.472s23.074 4.822 93.329 3.788c70.255-1.033 108.827-9.298 119.158-12.053 0 0 2.41-12.743 3.1-20.319Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.108 331.754c1.47-7.595 6.37-21.806 6.37-21.806s8.16 11.556 11.869 19.647c3.708 8.09 0 11.124-3.371 11.799-3.371.674-16.519-3.709-16.519-3.709l1.65-5.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.442 283.08c-6.733.386-16.203 1.383-23.543 2.979-7.921 1.721-10.676 2.066-12.054 3.443-1.377 1.378-14.809 18.253-19.63 30.306 0 0 .689 3.1 3.788 3.1 1.127 0 15.592 2.185 33.544 4.966 3.003-10.687 9.043-29.515 17.895-44.795Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.349 345.907-9.796-1.769s-2.398.763-1.672 3.161c.726 2.398 2.023 2.136 2.023 2.136l8.157 1.314s1.94.21 2.356-1.726c.416-1.935.966-2.185-1.068-3.116ZM280.818 337.372l-7.48-1.437s-1.83.62-1.276 2.568 1.545 1.735 1.545 1.735l6.228 1.067s1.481.17 1.799-1.402c.317-1.572.737-1.775-.816-2.53ZM340.74 282.016s-13.966 25.972-16.417 47.533",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.138 333.96s-6.37 10.78-6.615 14.456c-.245 3.675.49 47.778 1.715 55.864M388.518 349.396s-5.39 17.886-5.636 31.362-.49 38.713-.49 38.713M280.466 324.649s-11.516 10.536-12.496 13.966c-.98 3.43.245 32.832.245 32.832M282.67 404.77s1.716 4.9 5.391 6.125c3.675 1.225 92.861 18.376 92.861 18.376",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.037 420.318s68.297.94 93.674-6.893c0 0-2.506 16.918-7.206 20.364-4.7 3.447-38.854 6.966-55.452 7.52-18.798.626-29.45-1.254-29.45-1.254l-1.566-19.737ZM528.818 377.71l6.893 14.098s38.535.94 42.92 1.254c4.387.313 9.086 2.506 14.099 0 5.012-2.507 26.63-5.326 29.136-5.326s5.64 2.193 5.64 2.193-5.64-14.098-7.833-15.352c-2.193-1.253-4.386-.94-5.326-.94-.94 0-46.68-3.446-85.529 4.073Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.19 349.569s-16.384-2.52-22.686-.315-3.15 10.713 7.562 18.59 19.535 15.439 30.563 16.7c11.028 1.26 29.933 5.356 30.879 1.89.945-3.466-2.521-16.07-15.125-25.207-12.603-9.137-31.193-11.658-31.193-11.658ZM587.892 331.607l-3.145.95s-5.845.177-15.2.435c-8.015.235-18.602.528-30.303.833-16.15.435-34.411.88-50.901 1.233-25.21.528-46.313.798-49.482.328-5.445-.798-11.537-2.77-17.194-7.722-3.18-2.77-6.232-6.49-8.955-11.49-7.57-13.873-26.782-30.88-26.782-30.88 30.245-3.473 102.401-2.206 110.593-1.889 2.042.07 4.66.388 7.57.916 8.744 1.549 20.152 4.988 26.771 9.483 1.174.798 3.063 2.054 5.434 3.638 5.54 3.697 13.755 9.143 22.006 14.612 4.976 3.286 9.964 6.584 14.39 9.519 8.684 5.727 15.198 10.034 15.198 10.034Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.864 293.804c1.174.798 3.063 2.054 5.434 3.638l-47.955 37.616c-25.21.528-46.313.798-49.482.328-5.445-.798-11.537-2.77-17.194-7.722l82.426-43.343c8.744 1.549 20.152 4.988 26.771 9.483ZM572.693 321.572l-3.145 11.42c-8.016.235-18.603.528-30.304.833l19.06-21.77c4.976 3.285 9.964 6.583 14.39 9.517Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.977 368.283c1.92 1.943 3.774 4.001 5.532 6.177M473.52 340.431s23.848 7.015 43.146 24.668M626.265 373.904a56.077 56.077 0 0 1 5.427 15.05M589.786 341.692s21.126 8.184 33.794 27.658",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.425 426.45c0 3.654-3.527 6.616-7.877 6.616s-7.877-2.962-7.877-6.617 3.526-6.616 7.877-6.616 7.877 2.962 7.877 6.616ZM655.56 415.698c-.666 3.15-2.793 5.368-4.75 4.954-1.959-.414-3.006-3.303-2.34-6.453.666-3.15 2.793-5.367 4.75-4.953 1.958.414 3.006 3.303 2.34 6.452Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.136 337.876s-5.496-9.257-8.968-9.836c-3.471-.579-18.225-1.157-21.407.868-3.182 2.025-2.315 8.679-1.157 10.414 1.157 1.736 5.785 2.604 9.835 2.315 4.05-.29 17.647.868 17.647.868s8.1 5.785 10.993 5.207c2.893-.579 6.654-6.943 4.05-10.415-2.603-3.471-6.653-2.603-10.993.579Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m387.136 337.876 9.547 2.025M301.878 283.992s-8.265 2.411-9.298 4.822a202.99 202.99 0 0 0-1.722 4.132l-24.796 36.161s-8.954-.689-11.71 6.888c-2.754 7.576-1.721 17.908-1.721 17.908s-6.544 16.186-6.888 28.24c-.344 12.053 1.033 21.008 1.033 21.008s-1.722-22.041 3.444-28.93c5.166-6.887 15.842-1.72 19.975 10.677 4.132 12.398 8.954 35.472 8.954 35.472l109.17 22.385s-5.51-28.928 1.723-45.459c7.232-16.53 40.982-15.498 47.18 14.464 6.2 29.962 4.134 35.472 4.134 35.472s23.074 4.822 93.329 3.788c70.255-1.033 108.827-9.298 119.158-12.053 0 0 2.41-12.742 3.1-20.319.688-7.577-2.067-12.742-2.067-12.742s-.688-13.776-2.41-18.597c-1.722-4.822-6.888-12.054-6.888-12.054s-5.166-12.053-13.776-19.63c-8.61-7.577-22.73-15.153-26.173-16.875-3.444-1.722-7.921-2.755-14.465-7.232-6.543-4.477-47.18-32.717-59.923-40.294-12.742-7.576-40.294-11.364-45.804-12.398-5.51-1.033-68.877-5.51-90.918-5.51s-67.5 1.033-92.64 10.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.404 346.733s-6.932 2.52-5.042 5.041c1.89 2.521 12.289 9.138 17.015 17.33 4.726 8.192 5.671 12.288 7.877 12.288s6.976-4.082 6.324-6.137c-.653-2.055-4.118-20.645-26.174-28.522Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.713 409.865c-.072-3.387-.42-6.613-.987-9.547l-4.658 5.678c.2 1.204.329 2.496.358 3.848.004.194 0 .383 0 .574l5.291 1.676c.012-.735.012-1.477-.004-2.229ZM264.457 399.449c.484.514.928 1.224 1.32 2.081l3.28-9.818c-1.14-2.425-2.486-4.256-3.952-5.301l-.648 13.038ZM266.76 416.237c-.237.926-.531 1.75-.87 2.45l2.693 11.728c1.29-2.105 2.346-4.98 3.068-8.377l-4.89-5.801ZM258.834 403.737l-4.75-6.429c-.697 3.159-1.102 6.78-1.136 10.656l5.31.295c.058-1.648.258-3.18.576-4.522ZM260.45 399.828c.387-.53.814-.914 1.268-1.133l-.777-13.034c-1.68.579-3.201 2.215-4.454 4.636l3.963 9.531ZM263.579 421.097a1.909 1.909 0 0 1-.505.07c-.484-.001-.955-.191-1.4-.537l-2.604 11.234c1.314 1.51 2.766 2.36 4.28 2.366.414.001.82-.067 1.217-.188l-.988-12.945ZM258.795 414.673l-5.253 2.285c.543 3.736 1.432 7.088 2.563 9.827l3.371-9.677a18.746 18.746 0 0 1-.681-2.435Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.555 312.676s58.142 3.252 63.255 5.382c5.112 2.13 6.39 7.243 6.39 7.243l-72.855-2.556 3.21-10.069Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.059 284.053s-33.146 24.106-45.714 38.692l-12.782-2.557 35.454-34.014 23.042-2.121Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.323 329.55s6.265-30.558 16.417-47.534c0 0-35.586-4.789-74.357 1.176-2.253.346-37.376 29.753-37.376 29.753s-20.502 17.505-20.877 20.877c0 0 12.717 44.286 59.013 74.528l50.276 8.127s-3.366-54.604-2.875-66.382c.297-7.13 9.78-20.546 9.78-20.546Zm-84.239-11.066c-5.112-1.704 0-6.817 0-6.817l30.341-24.215c20.877-3.408 58.705.356 58.705.356-2.556 4.687-11.93 37.493-11.93 37.493s-72.003-5.112-77.116-6.817Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.891 330.547-6.428-.56s-2.516.28-2.516 2.516 1.957 2.516 1.957 2.516l12.459 1.127s-.295-3.77 1.662-4.888l-7.134-.711Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.254 335.764s2.048 2.662 4.097 2.662 9.83.82 9.83.82",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m621.675 289.214 2.475-.19 10.47 31.79-2.965.373-9.98-31.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.633 287.642s3.702-2.02 4.544-2.02c.841 0 3.87 4.04 3.87 4.04s-4.207 2.355-4.712 2.523c-.505.169-3.365-1.178-3.365-1.178s-2.861 2.188-4.208 4.712c-1.346 2.525-6.9 11.78-6.9 11.78s-3.029 4.376-6.226 2.525c-3.198-1.851-4.376-6.227-3.03-8.078 1.347-1.851 20.027-14.304 20.027-14.304Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.772 292.354s1.01 1.178 2.02 1.346c1.01.168 3.87.168 3.87.168s3.198-.336.673-1.683c-2.524-1.346-4.544-2.02-4.544-2.02M141.036 211.496l-13.514 9.825-12.312-9.531-.015-.01c-5.575-3.968-9.214-10.483-9.214-17.849 0-12.083 9.8-21.878 21.883-21.878s21.878 9.795 21.878 21.878c0 7.254-3.275 13.582-8.706 17.565Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.656 193.788c0 4.666 1.663 8.947 4.425 12.284 3.532 4.255 8.86 6.965 14.825 6.965 5.498 0 10.451-2.3 13.962-5.99a19.197 19.197 0 0 0 5.288-13.26c0-10.63-8.614-19.25-19.25-19.25-10.631 0-19.25 8.62-19.25 19.25Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.906 213.037a19.18 19.18 0 0 0 12.453-4.569c-.629-6.507-6.11-11.596-12.783-11.596-6.49 0-11.842 4.818-12.709 11.07a19.177 19.177 0 0 0 13.039 5.095Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.576,
    cy: 188.183,
    r: 8.483,
    transform: "rotate(-73.155 127.576 188.183)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.809 272.844-13.515 9.824-12.311-9.53-.016-.01c-5.574-3.969-9.214-10.483-9.214-17.85 0-12.083 9.8-21.877 21.883-21.877s21.878 9.794 21.878 21.878c0 7.253-3.274 13.582-8.705 17.565Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.429 255.135c0 4.666 1.663 8.948 4.424 12.284 3.532 4.256 8.86 6.966 14.825 6.966 5.498 0 10.452-2.3 13.963-5.99a19.197 19.197 0 0 0 5.287-13.26c0-10.63-8.614-19.25-19.25-19.25-10.63 0-19.25 8.62-19.25 19.25Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.678 274.385a19.18 19.18 0 0 0 12.453-4.57c-.629-6.507-6.11-11.595-12.783-11.595-6.49 0-11.842 4.818-12.709 11.07a19.177 19.177 0 0 0 13.04 5.095Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.348,
    cy: 249.531,
    r: 8.483,
    transform: "rotate(-76.668 362.348 249.531)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.172,
    cy: 456.611,
    rx: 50.519,
    ry: 4.975,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.814 429.859 5.2 16.03s7.682 1.752 9.57 1.523 8.802-1.642 8.962-.321c.16 1.321-2.036 2.162-2.722 2.82s-5.485 3.73-7.304 4.525c-1.819.795-7.367 2.425-8.997 3.198-1.63.772-3.569 2.156-4.833-.372s-1.842-5.714-2.048-7.413-8.552-15.242-8.552-15.242l10.724-4.748Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.583 447.412c-.334.04-.795.015-1.32-.05l.44 2.264s-10.052 3.662-15.068 4.923c.283.924.626 1.856 1.055 2.713 1.264 2.528 3.203 1.144 4.833.372 1.63-.773 7.178-2.403 8.997-3.198 1.819-.795 6.617-3.867 7.304-4.525.686-.658 2.882-1.499 2.722-2.82-.16-1.321-7.075.092-8.963.32Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.257 274.422s3.11-.648 2.787.065c-.324.713-2.528 1.231-2.528 1.231s2.398.065 1.945.584-1.75.648-1.75.648l-1.037 1.037s-.973.907-1.232 1.166c-.259.26-2.333 1.88-2.787 1.037-.453-.842 0-2.592.454-2.981.454-.389 4.148-2.787 4.148-2.787Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.127 284.565 16.671 9.094 29.312-10.506s1.277-1.928 3.15-4.972c1.874-3.045 5.18-4.468 6.624-5.356 1.444-.887 2.677-.471 2.263.42-.415.89-3.093 1.704-3.644 2.32-.55.616-3.306 4.38-3.306 4.38s4.947-2.454 5.77-2.52c.824-.066 1.302.553.133 1.304-1.168.751-3.161 1.911-3.575 2.459-.413.547-1.377 1.71-2.134 2.257-.756.546-1.993 1.16-1.993 1.16s-28.337 18.988-29.87 19.755-4.756.767-4.756.767l-15.34-6.29.695-14.272Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.729 292.278-3.93 1.381-16.672-9.094-.695 14.273 15.34 6.29s3.221 0 4.755-.768c.353-.176 2.334-1.37 5.162-3.096l-3.96-8.986Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.644 426.147-4.932 11.712s-7.055 6.825-6.966 7.799 1.169 3.3 3.169 4.329 5.099 2.709 5.099 2.709 4.792 3.14 7.801 3.847c3.01.706 6.181 1.916 6.67.313.488-1.604-5.241-4.89-5.241-4.89s-2.591-4.96-3.077-6.475c-.485-1.514-.211-4.83-.211-4.83l9.004-10.123-11.316-4.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.244 451.966s-1.911-.056-3.28-.508c-1.37-.452-4.522-3.34-7.565-6.93a34.369 34.369 0 0 0-3.125-3.216c-1.778 1.852-3.573 3.852-3.527 4.346.089.973 1.168 3.3 3.168 4.329 2 1.03 5.099 2.709 5.099 2.709s4.792 3.14 7.801 3.847c3.01.706 6.181 1.916 6.67.313s-5.241-4.89-5.241-4.89Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m107.62 352.903-.061 36.111-18.557 36.37 16.747 9.988 20.076-38.283 4.874-26.877-23.078-17.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.467 333.287s-4.231 13.847-3.462 16.924c.77 3.077 23.992 49.774 23.992 49.774l18.703 38.309 20.77-6.154-17.693-50.004-13.077-30.771v-16.54l-29.233-1.538ZM135.542 266.074l-1.872 4.916-4.844-2.532.576-5.28 6.14 2.896z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.678 272.242s-2.902.872-2.594 3.698c.308 2.825 4.791 13.71 5.892 19.501 1.102 5.791.17 7.107.366 9.649s-.967 26.2-.63 30.332-1.27 4.43-12.114 4.192c-10.842-.237-16.984-1.695-20.395-3.642-3.41-1.947-1.826-4.924-.62-7.313 1.206-2.39 6.191-33.664 8.787-41.572 2.595-7.908 3.073-10.848 7.32-13.693 4.25-2.845 4.82-2.31 5.112-3.538.292-1.228.962-3.046.962-3.046l7.914 5.432Z",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.18 302.65s2.902 3.155 6.911 3.593M125.666 313.37c.38.498.78.974 1.205 1.416M120.835 303.174s1.203 4.518 3.68 8.515",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.764 243.895s1.402 3.104.28 6.402c-1.124 3.299-1.414 4.903-.533 6.203s1.258 2.906-.167 3.697c-1.426.791-2.31.826-2.31.826s-2.534 6.2-4.212 6.81c-1.678.611-7.139-1.489-8.886-2.646-1.748-1.157-.323-13.4.888-15.49s14.94-5.802 14.94-5.802Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.887 261.033c-1.875.087-2.666-2.006-2.666-2.006s-1.184 3.474.263 3.956c1.446.483 2.403-1.95 2.403-1.95Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.832 254.095c-.172.845-.668 1.458-1.107 1.369-.439-.09-.655-.847-.483-1.692.172-.845.667-1.458 1.106-1.368.44.089.656.846.484 1.691Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.12 237.95s.083 4.545-3.311 6.884c-3.394 2.34-12.09 4.888-13.407 5.661-1.318.774-1.302 2.216-1.302 2.216s-1.238 7.987-1.225 11.432 3.146 6.262 2.007 8.785c-1.14 2.523-4.783 2.68-7.11 2.73-2.326.051-1.664 3.388-5.76 5.51-4.097 2.122-7.378 1.107-9.573-2.088-2.196-3.195-1.13-4.816-3.022-5.504s-4.978.822-7.188-4.483c-2.21-5.306-.203-9.306 1.403-10.35 1.607-1.043 7.666-.71 7.351-7.328-.315-6.619 5.291-17.106 13.593-21.368 8.302-4.262 21.652 3.873 23.455 4.687s4.145 1.54 4.088 3.216Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.148 326.079s-4.671-35.163-8.475-43.612c-3.804-8.448-7.773-12.503-13.775-5.125-6.003 7.38-8.82 50.547-8.82 50.547",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.749 287.724s-13.901 32.442-16 34.523c-2.097 2.08-9.957 6.458-11.966 1.32-2.01-5.137 14.776-43.088 18.505-46.915 3.729-3.827 10.83-2.28 11.002 4.517",
    style: {
      fill: "#ffc100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.946 319.03s2.904-.63 4.491-2.189c1.588-1.56 3.541-2.134 5.253-1.947 1.713.186 4.082.13 4.206 1.876s-1.084 2.717-1.585 2.978c-.5.26-.99 6.192-2.337 6.99-1.347.799-6.555-.557-8.406-.916s-13.554 1.515-19.47.87c-5.915-.646-11.242-.911-11.315-3.125s2.784-8.202 9.424-8.423c6.64-.221 12.182 3.849 19.739 3.885Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.148 326.079s-2.867 1.735-16.285 2.005c-13.418.269-14.785-.195-14.785-.195s-3.992 17.211-2.555 19.096c2.618 3.436 29.627 2.758 32.268.21 2.64-2.546 1.357-21.116 1.357-21.116Z",
    style: {
      fill: "#969696",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.947 251.26s.915-1.42 2.63-.681",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner9);
export default __webpack_public_path__ + "static/media/banner9.4a3fc620621775276ece82062d826ca9.svg";
export { ForwardRef as ReactComponent };